import { jsx } from "react/jsx-runtime";
import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import { validateTidalLicense } from "../../base/index.js";
function ContentPasteOutlined(props) {
  return /* @__PURE__ */ jsx(
    ContentPasteOutlinedIcon,
    {
      "data-testid": "ContentPasteOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ContentPasteOutlined",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
ContentPasteOutlined.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "ContentPasteOutlined"
};
validateTidalLicense();
export {
  ContentPasteOutlined
};
//# sourceMappingURL=ContentPasteOutlined.js.map
